import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Loga no console para debug, sem tela preta silenciosa
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  handleReload = () => {
    // Tenta limpar SW cache e recarregar a página
    try {
      if ("caches" in window) {
        caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k))));
      }
    } catch (_) { /* ignora */ }
    try {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
      }
    } catch (_) { /* ignora */ }
    window.location.reload();
  };

  handleGoLogin = () => {
    window.location.href = "/login";
  };

  render() {
    if (!this.state.error) return this.props.children;

    const msg = this.state.error?.message || String(this.state.error);

    return (
      <div className="min-h-screen w-full bg-[#0A0A0A] text-[#E5E5E5] flex items-center justify-center px-6 py-10">
        <div className="max-w-md w-full text-center">
          <div className="inline-flex w-12 h-12 rounded-md bg-red-500/10 border border-red-500/30 items-center justify-center mb-5">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fca5a5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 9v4"/><path d="M12 17h.01"/><path d="M10.29 3.86l-8.18 14.18a2 2 0 0 0 1.71 3h16.36a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            </svg>
          </div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-red-300">Algo deu errado</div>
          <h1 className="font-display text-2xl font-bold mt-2">Não foi possível exibir esta tela</h1>
          <p className="text-[13px] text-[#A3A3A3] mt-3 leading-relaxed">
            Detectamos um erro de renderização. Seus dados estão seguros — nada foi perdido. Tente recarregar a página.
            Se o problema persistir, faça login novamente.
          </p>
          <details className="mt-4 text-left text-[11px] text-[#737373] bg-[#0f0f0f] border border-[#262626] rounded-md p-2.5">
            <summary className="cursor-pointer">Detalhes técnicos</summary>
            <pre className="mt-2 whitespace-pre-wrap break-all">{msg}</pre>
          </details>
          <div className="flex flex-col sm:flex-row gap-2 mt-5">
            <button
              type="button"
              onClick={this.handleReload}
              className="fc-btn-gold flex-1 text-sm py-2.5"
              data-testid="error-reload"
            >
              Recarregar
            </button>
            <button
              type="button"
              onClick={this.handleGoLogin}
              className="fc-btn-ghost flex-1 text-sm py-2.5"
              data-testid="error-login"
            >
              Ir para login
            </button>
          </div>
        </div>
      </div>
    );
  }
}
